import { stringify } from 'qs';
import request from '@/services/request';
import { url } from './service-utils';

/**
 * 页面：获取学期下班级列表
 * 前端：洪芳
 * 后端： 陈新
 */
export async function getClass(params) {
  return request(`${url.url}/course/term/timetable/week-between?${stringify(params)}`);
}

/**
 * 页面：获取学期的周期列表
 * 前端：洪芳
 * 后端： 陈新
 */
export async function getWeekList(params) {
  return request(`${url.url}/course/term/timetable/week-list?${stringify(params)}`);
}

/**
 * 页面：获取学期总课表
 * 前端：洪芳
 * 后端： 陈新
 */
export async function getCollectData(params) {
  return request(`${url.url}/course/term/timetable/collect?${stringify(params)}`);
}

/**
 * 页面：获取周期类型
 * 前端：洪芳
 * 后端： 陈新
 */
export async function getWeekType(params) {
  return request(`${url.url}/course/term/week-type?${stringify(params)}`);
}

/**
 * 页面：修改课表
 * 前端：洪芳
 * 后端： 陈新
 */
export async function modifyCourse(params) {
  return request(`${url.url}/course/term/timetable/collect`, {
    method: 'put',
    data: params,
  });
}

/**
 * 页面：获取学期下单个班级的课程列表汇总
 * 前端：洪芳
 * 后端： 陈新
 */
export async function getClassCourse(params) {
  return request(`${url.url}/course/term/class/class-course-list?${stringify(params)}`);
}

/**
 * 页面：根据选人组件id转换具体用户信息
 * 前端：洪芳
 * 后端： 陈新
 */
export async function getSelectUser(params) {
  return request(`${url.url}/course/term/timetable/selectId-to-user?${stringify(params)}`);
}

/**
 * 页面：课表学期列表
 * 前端：洪芳
 * 后端： 陈新
 */
export async function courseList(params) {
  return request(`${url.url}/course/term/find?${stringify(params)}`);
}
